import { api } from '../api'

export const getAssessmentProgress = async (
  maxHands?: number
): Promise<{
  handsPlayed: number
  maxHands: number
  progress: number
  error: string | null
}> => {
  const params = new URLSearchParams()
  if (maxHands !== undefined) {
    params.set('maxHands', maxHands.toString())
  }

  const queryString = params.toString()
  const url = `/api/assessment/progress${queryString ? `?${queryString}` : ''}`

  return await api().url(url).get().json()
}
